let handler: () => void

export const handlePageVisibility = (
  visibleCallback?: () => void,
  hiddenCallback?: () => void
) => {
  if (handler) {
    document.removeEventListener('visibilitychange', handler)
  }

  handler = () => {
    if (document.visibilityState === 'hidden') {
      return hiddenCallback?.()
    }

    visibleCallback?.()
  }

  document.addEventListener('visibilitychange', handler)
}
